// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"

import { colors } from "../../../utils/theme/colors"
import { Link } from "gatsby"

const Paragraph = ({ children, url }) => {
  return url === undefined ? (
    <p
      sx={{
        color: colors.code.footerText,
        fontSize: `0.94rem`,
        lineHeight: 2.33,
        margin: 0,
      }}
    >
      {children}
    </p>
  ) : (
    <Link
      sx={{
        textDecoration: `none`,
        color: colors.code.footerText,
        fontSize: `0.94rem`,
        lineHeight: 2.33,
        margin: 0,
      }}
      to={url}
    >
      {children}
    </Link>
  )
}

export default Paragraph
